module.exports = __webpack_public_path__ + "static/img/adaptive-capacity-lowres.66aa962.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maps/adaptive-capacity-lowres.png
// module id = OzNW
// module chunks = 1